import { createAction } from '@reduxjs/toolkit';
import { JOINT_INITIAL_QUESTION } from 'constants/paths';
import { ORIGIN_IB } from 'constants/general';
import { getDeviceContext } from 'utils/deviceContext';
import { responseFailed, authCodeFailed } from './error';
import { getNextTask } from './case';
import { showHideLoader } from './loader';
import { navigateToScreen } from './navigation';

export const authCodeDetails = createAction(
  'case/authCodeDetails',
  function prepare(caseId, lettercode) {
    return {
      payload: {
        endPoint: `banks/:bankId/cases/personal-loan/${caseId}/tasks/lettercode`,
        method: 'post',
        body: authCodeRequest(lettercode),
        isPaasApi: true,
        addHeader: true,
        success: authCodeSuccess,
        successParam: {
          caseId
        },
        failure: authCodeFailed,
        version: '1.2.0'
      }
    };
  }
);

const authCodeRequest = (lettercode) => {
  return {
    lettercode: lettercode
  };
};

export const authCodeSuccess = (response, param) => (dispatch) => {
  if (response) {
    dispatch(authCodeSuccessResponse(response));
    dispatch(getNextTask(param.caseId));
  } else dispatch(responseFailed(response));
};

export const authCodeSuccessResponse = createAction(
  'case/authCodeSuccessResponse',
  function prepare(response) {
    return {
      payload: response
    };
  }
);

export const getLinkCode = (caseId) => (dispatch) => {
  dispatch(showHideLoader(true));
  dispatch(callLinkCodeAPI(caseId));
};

const linkCodeSuccess = (response) => (dispatch, getState) => {
  if (response) {
    dispatch(showHideLoader(false));
    dispatch(linkCodeSuccessResponse(response));
    dispatch(startSecondaryApplicantJourney());
  } else dispatch(responseFailed(response));
};

const callLinkCodeAPI = createAction('authCode/callLinkCodeAPI', function prepare(caseId) {
  return {
    payload: {
      endPoint: `/banks/:bankId/cases/personal-loan/${caseId}/tasks/pending/applicant`,
      method: 'get',
      isPaasApi: true,
      addHeader: true,
      success: linkCodeSuccess,
      failure: responseFailed,
      version: '1.2.0'
    }
  };
});

export const linkCodeSuccessResponse = createAction(
  'authCode/linkCodeSuccessResponse',
  function prepare({ joint_link_code }) {
    return {
      payload: joint_link_code
    };
  }
);

const startSecondaryApplicantJourney = () => (dispatch, getState) => {
  const { isNative } = getDeviceContext();

  const {
    config: {
      bankId,
      jointLinkCode,
      origin,
      configUrls: { personalLoansUrl }
    }
  } = getState();

  if (isNative) {
    window.location.href = personalLoansUrl.concat(
      '?external=true#jointLinkCode=',
      jointLinkCode,
      '&bankId=',
      bankId,
      '&isJoint=true'
    );
  } else if (origin === ORIGIN_IB) {
    window.open(
      personalLoansUrl.concat('#jointLinkCode=', jointLinkCode, '&bankId=', bankId, '&isJoint=true')
    );
  } else {
    dispatch(navigateToScreen(JOINT_INITIAL_QUESTION));
  }
};

export const updateJointLinkCode = createAction(
  'authCode/updateJointLinkCode',
  function prepare(linkCode) {
    return {
      payload: linkCode
    };
  }
);
